import React, { useMemo } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { Field } from 'formik';
import Select from 'react-select';
import { FaSearch, FaUsers, FaUser } from 'react-icons/fa';
import { DropdownIndicator, customStyles } from '~/Styles/reactSelectStyles';
import {
  FILTRO_OPTIONS,
  SEXO_OPTIONS,
  TIPO_RENDA_OPTIONS,
} from './UtilsConvesaoLeads';

const SectionCard = function(props) {
  return (
    <div className="cl-section">
      <div className="cl-section__header">
        <h6 className="cl-section__title">
          {props.icon && <span className="icon">{props.icon}</span>}
          {props.title}
        </h6>
        {props.headerRight}
      </div>
      <div className="cl-section__body">{props.children}</div>
    </div>
  );
};

const FiltrosPrincipais = function(props) {
  const values = props.values;
  const setFieldValue = props.setFieldValue;
  const origemOpts = props.origemOpts;
  const empreendimentosOpts = props.empreendimentosOpts;
  const isLoadingEmp = props.isLoadingEmp;
  const cidadesOpts = props.cidadesOpts;
  const profissaoOpts = props.profissaoOpts;
  const pdvOpts = props.pdvOpts;
  const statusOpts = props.statusOpts;
  const gerentesOpts = props.gerentesOpts;
  const corretoresOpts = props.corretoresOpts;
  const atendenteOpts = props.atendenteOpts;

  const corretoresFiltrados = useMemo(
    function() {
      const gerenteSelecionado = values.gerente;
      if (!corretoresOpts || corretoresOpts.length === 0)
        return [{ value: '', label: 'Todos' }];

      if (
        !gerenteSelecionado ||
        gerenteSelecionado === 'Todos' ||
        gerenteSelecionado === ''
      ) {
        return corretoresOpts;
      }

      const filtrados = corretoresOpts.filter(function(opt) {
        if (opt.value === 'Todos') return true;
        return String(opt.gerenteCodigo) === String(gerenteSelecionado);
      });

      if (filtrados.length <= 1) return corretoresOpts;
      return filtrados;
    },
    [corretoresOpts, values.gerente]
  );

  const handleSelect = function(nome, selectedOption) {
    setFieldValue(nome, selectedOption ? selectedOption.value : '');
  };

  const handleMultiSelect = function(nome, selectedOptions) {
    setFieldValue(
      nome,
      selectedOptions && selectedOptions.length > 0
        ? selectedOptions
            .map(function(o) {
              return o.value;
            })
            .join(',')
        : ''
    );
  };

  const selectProps = {
    styles: customStyles,
    components: { DropdownIndicator: DropdownIndicator },
  };

  return (
    <>
      <SectionCard title="Busca Rápida" icon={<FaSearch />}>
        <Row>
          <Col md={2}>
            <Form.Group>
              <small>Filtro</small>
              <Select
                placeholder="Nenhum"
                options={FILTRO_OPTIONS}
                defaultValue={FILTRO_OPTIONS[0]}
                onChange={function(opt) {
                  handleSelect('filtro', opt);
                }}
                isClearable={false}
                {...selectProps}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <small>Valor</small>
              <Field
                type="text"
                name="filtro_adicional"
                className="form-control form-control-sm"
                placeholder="Digite o valor..."
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <small>Empreendimento</small>
              <Select
                placeholder={isLoadingEmp ? 'Carregando...' : 'Selecione...'}
                options={empreendimentosOpts.filter(function(o) {
                  return o.value !== '';
                })}
                isClearable
                isMulti
                onChange={function(opts) {
                  handleMultiSelect('empreendimento', opts);
                }}
                isDisabled={isLoadingEmp}
                value={
                  isLoadingEmp || !values.empreendimento
                    ? []
                    : values.empreendimento
                        .split(',')
                        .map(function(v) {
                          return empreendimentosOpts.find(function(o) {
                            return String(o.value) === v;
                          });
                        })
                        .filter(Boolean)
                }
                {...selectProps}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <small>Status</small>
              <Select
                placeholder="Selecione..."
                options={statusOpts.filter(function(o) {
                  return o.value !== '';
                })}
                isClearable
                isMulti
                onChange={function(opts) {
                  handleMultiSelect('status', opts);
                }}
                value={
                  !values.status
                    ? []
                    : values.status
                        .split(',')
                        .map(function(v) {
                          return statusOpts.find(function(o) {
                            return String(o.value) === v;
                          });
                        })
                        .filter(Boolean)
                }
                {...selectProps}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <small>Origem</small>
              <Select
                placeholder="Todos"
                options={origemOpts}
                defaultValue={origemOpts.length ? origemOpts[0] : null}
                onChange={function(opt) {
                  handleSelect('origem', opt);
                }}
                {...selectProps}
              />
            </Form.Group>
          </Col>
        </Row>
      </SectionCard>

      <Row>
        <Col md={6}>
          <SectionCard title="Equipe Comercial" icon={<FaUsers />}>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <small>Gerente</small>
                  <Select
                    placeholder="Todos"
                    options={gerentesOpts}
                    value={
                      gerentesOpts.find(function(o) {
                        return String(o.value) === String(values.gerente);
                      }) || (gerentesOpts.length ? gerentesOpts[0] : null)
                    }
                    isClearable
                    onChange={function(opt) {
                      handleSelect('gerente', opt);
                      setFieldValue('corretor', 'Todos');
                    }}
                    {...selectProps}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <small>Corretor</small>
                  <Select
                    placeholder="Todos"
                    options={corretoresFiltrados}
                    value={
                      corretoresFiltrados.find(function(o) {
                        return String(o.value) === String(values.corretor);
                      }) ||
                      (corretoresFiltrados.length
                        ? corretoresFiltrados[0]
                        : null)
                    }
                    isClearable
                    onChange={function(opt) {
                      handleSelect('corretor', opt);
                    }}
                    {...selectProps}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <small>Atendente</small>
                  <Select
                    placeholder="Todos"
                    options={atendenteOpts}
                    isClearable
                    onChange={function(opt) {
                      handleSelect('atendente', opt);
                    }}
                    {...selectProps}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <small>PDV</small>
                  <Select
                    placeholder="Selecione..."
                    options={pdvOpts}
                    isClearable
                    onChange={function(opt) {
                      handleSelect('pdv', opt);
                    }}
                    {...selectProps}
                  />
                </Form.Group>
              </Col>
            </Row>
          </SectionCard>
        </Col>

        <Col md={6}>
          <SectionCard title="Prospecto" icon={<FaUser />}>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <small>Sexo</small>
                  <Select
                    placeholder="Ambos"
                    options={SEXO_OPTIONS}
                    defaultValue={SEXO_OPTIONS[0]}
                    isClearable
                    onChange={function(opt) {
                      handleSelect('sexo', opt);
                    }}
                    {...selectProps}
                  />
                </Form.Group>
                <Form.Group>
                  <small>Profissão</small>
                  <Select
                    placeholder="Selecione..."
                    options={profissaoOpts}
                    isClearable
                    onChange={function(opt) {
                      handleSelect('profissao', opt);
                    }}
                    {...selectProps}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <small>Cidade</small>
                  <Select
                    placeholder="Selecione..."
                    options={cidadesOpts}
                    isClearable
                    onChange={function(opt) {
                      handleSelect('cidade', opt);
                    }}
                    {...selectProps}
                  />
                </Form.Group>
                <Form.Group>
                  <small>Tipo de Renda</small>
                  <Select
                    placeholder="Selecione..."
                    options={TIPO_RENDA_OPTIONS}
                    isClearable
                    onChange={function(opt) {
                      handleSelect('tipo_renda', opt);
                    }}
                    {...selectProps}
                  />
                </Form.Group>
              </Col>
            </Row>
          </SectionCard>
        </Col>
      </Row>
    </>
  );
};

export default FiltrosPrincipais;
